import React, { memo, useMemo } from 'react'
import ViewOffIcon from 'transfix-icons/build/ViewOffIcon'
import Tooltip from 'transfix-ui/components/Tooltip'
import Skeleton from 'transfix-ui/core/Skeleton'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { HOMEPAGE_BOX_SHADOW } from 'apps/fleet-planner/pages/home/constants'
import { useActiveInternalShipmentsCountQuery } from '../../graphql/ActiveInternalShipmentsCount'

const useActiveShipmentsInternalCountIndicatorStyles = makeStyles(theme => ({
  card: {
    display: 'inline-block',
    background: brandColors.white,
    borderRadius: theme.spacing(0.5),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    boxShadow: HOMEPAGE_BOX_SHADOW,
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  count: {
    color: brandColors.coolGray5,
  },
  tooltipContent: {
    backgroundColor: 'transparent !important',
    maxWidth: '165px',
  },
}))

export interface IActiveShipmentsInternalCountIndicatorProps {}

const ActiveShipmentsInternalCountIndicator = memo<IActiveShipmentsInternalCountIndicatorProps>(
  () => {
    const classes = useActiveShipmentsInternalCountIndicatorStyles()

    const { data, loading } = useActiveInternalShipmentsCountQuery({
      fetchPolicy: 'cache-and-network',
    })
    const { shipments } = data || {}
    const { totalCount = 0 } = shipments || {}

    const showCount = useMemo(() => {
      if (loading) {
        return true
      }
      return totalCount > 0
    }, [loading, totalCount])

    const tooltipText = useMemo(() => {
      if (totalCount === 1) {
        return `${totalCount} manually added load is not represented on this map`
      }
      return `${totalCount} manually added loads are not represented on this map`
    }, [totalCount])

    return showCount ? (
      <Tooltip
        id='internal-count'
        position='right'
        trigger={
          <div className={classes.card}>
            <div className={classes.cardContent}>
              <ViewOffIcon size='medium' color='coolGray5' />
              {loading ? (
                <Skeleton variant='rectangular' width={20} height={16} />
              ) : (
                <Typography variant='body2' component='div' className={classes.count}>
                  {totalCount}
                </Typography>
              )}
            </div>
          </div>
        }>
        <div className={classes.tooltipContent}>{tooltipText}</div>
      </Tooltip>
    ) : null
  }
)

export default ActiveShipmentsInternalCountIndicator
